import React from "react";
import { Backdrop } from "@mui/material";
import StepUpSpinner from "./StepUpSpinner";

interface LoaderProps {
  open: boolean;
}

const BackDrop: React.FC<LoaderProps> = ({ open }) => {
  return (
    <Backdrop
      sx={(theme) => ({
        zIndex: theme.zIndex.drawer + 2000,
        bgcolor: "rgba(255,255,255,0.85)",
        backdropFilter: "blur(6px)",
      })}
      open={open}
    >
      <StepUpSpinner size="large" label="Processing" />
    </Backdrop>
  );
};

export default BackDrop;
